<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { SelectDefinition, SelectNumberDefinition } from 'header/types';
    import SimpleSelect from 'portlet/common/components/SimpleSelect.svelte';

    interface Props {
        field: SelectDefinition | SelectNumberDefinition;
    }

    let { field }: Props = $props();

    type Options = SelectDefinition['options'][number] | SelectNumberDefinition['options'][number];

    let options = $derived(field.options as Array<Options>);
    let items = $derived(
        options.map(({ label, key: value }) => ({
            label,
            value,
        })),
    );
    let value = $derived(
        field.options
            .map(option => ({
                label: option.label,
                value: option.key,
            }))
            .filter(({ value }) => value === field.value),
    );

    const dispatch = createEventDispatcher();
    const onChange = (key: Options['key']) => {
        dispatch('change', {
            field: {
                ...field,
                value: key,
            },
        });
    };

    const handleDragStart = (
        e: DragEvent,
        option: {
            label: string;
            value: string | number;
        },
    ) => {
        if (!e.dataTransfer) return;
        e.dataTransfer.dropEffect = 'move';
        e.dataTransfer.setData('setting', JSON.stringify({ ...option, key: field.key }));
    };
</script>

<div data-testid="select">
    <SimpleSelect fullWidth disabled={field.changeable === false} {items} {value}>
        <li
            class="option"
            slot="item"
            class:selected
            let:item
            let:selected
            draggable="true"
            onclick={() => onChange(item.value)}
            ondragstart={e => handleDragStart(e, item)}
            data-testid={`option-${item.value}`}
        >
            {item.label}
        </li>
    </SimpleSelect>
</div>

<style lang="scss" scoped>
    li.option {
        display: block;
        align-items: center;
        padding: 3px 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.8rem;

        &:hover,
        &:focus {
            outline: none;
            background: #f2f2f2;
        }
        &.selected {
            font-weight: bold;
            background-color: #f2f2f2;
        }
    }
</style>
